/* app/ui/listing/map */

define(
	'app/ui/listing/map',[
		'jquery',
		'util/mediaqueries',
		'pubsub'
	],
	function ($, MediaQueries) {

		window.dataLayer = window.dataLayer || [];

		var Module;

		var classes;
		var $listingContainer;
		var firstLoad = true;
		var $listingBody;
		var $map;
		var $onBtn;
		var $offBtn;

		var selectors = {
			toggle: '.js-map-toggle',
			close: '.js-map-close',
			on: '.js-map-on',
			off: '.js-map-off'
		};

		return {
			init: function($elm, classList) {
				Module = this;
				$listingContainer = $elm;
				classes = classList;

				Module._initElements();
				Module._initEvents();
				Module._initMediaQueries();
			},

			_initElements: function () {
				$listingBody = $listingContainer.find('.js-operator-listing-body');
				$map = $listingContainer.find('.js-operator-map');
				$onBtn = $listingContainer.find('.js-map-on');
				$offBtn = $listingContainer.find('.js-map-off');
			},

			_initEvents: function() {
				$listingContainer.on('click', selectors.toggle, Module._toggleMap);
				$listingContainer.on('click', selectors.close, Module._toggleMap);
				$listingContainer.on('click', selectors.on, Module._toggleMapOn);
				$listingContainer.on('click', selectors.off, Module._toggleMapOff);
			},

			_initMediaQueries: function () {

				MediaQueries.register([
					{
						queries: MediaQueries.queries['megamenu--small'],
						shouldDegrade: false,
						match: function () {
							firstLoad = false;
						}
					}
				]);
			},

			_toggleMap: function (event) {
				event.preventDefault();

				$.publish('/operator/listing/overlay');

				$listingBody.toggleClass('map-open');
				$map.toggleClass(classes.open);
				$onBtn.toggleClass('is-selected');
				$offBtn.toggleClass('is-selected');

				if ($map.hasClass(classes.open)) {
					$.publish('/map/interactive/opened');
				}
			},

			_toggleMapOn: function (event) {
				event.preventDefault();
				Module._trackOpenMap();
				Module._toggleMap(event);
			},
			_toggleMapOff: function (event) {
				Module._toggleMap(event);
			},

			_trackOpenMap: function () {
				window.dataLayer.push({
					'event': 'customEvent',
					'eventDetails': {
						'category': 'Operator Map',
						'action': 'Open Map',
						'label': document.location.href
					}
				});
			}
		};
	}
);
